export default {
  stepPrepare: "准备付款",
  stepProcess: "处理付款",
  stepConfirm: "确认订单",
  preparing: "正在准备付款环境",
  confirmingPayment: "正在确认付款",
  confirmingOrder: "正在确认订单",
  possibleIssue: "检测到可能的问题",
  settingUp: "正在设置安全结账…",
  waitingConfirmation: "等待交易确认…",
  updatingAccount: "正在更新您的账户信息…",
  paymentSuccessful: "付款成功！",
  upgradeSuccess: "您的套餐已成功升级。",
  continue: "继续",
  somethingWentWrong: "您的付款出现问题。",
  tryAgain: "重试",
  paymentCancelled: "付款已取消",
  cancelledTransaction: "您关闭了付款窗口或取消了交易。",
  timeoutMessage:
    "可能出现了问题。您可以检查您的权益是否已生效。如需帮助，请联系我们的支持团队 {supportEmail}。",
  secureEncrypted: "您的付款详情已安全加密",
  havingTrouble: "遇到问题？请联系 {supportEmail}",
};
